package com.exura.features.publicplans.domain.usecase

import com.exura.features.plandefinition.domain.repository.PlanDefinitionRepository
import com.exura.features.plandefinition.usecase.GetTreatmentPlanUseCase
import com.exura.features.publicplans.domain.PublicPlansConstants
import com.exura.features.publicplans.domain.api.CreateNewPublicPlanRequest
import com.exura.features.publicplans.domain.api.CreateNewPublicPlanResponse
import com.exura.features.publicplans.domain.model.ProviderPublicPlan
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import dev.gitlive.firebase.functions.FirebaseFunctions

class CreateNewPublicPlanUseCase(
    private val functions: FirebaseFunctions,
    private val repository: ProviderPublicPlanRepository,
    private val getPlanDefinitionUseCase: GetTreatmentPlanUseCase,
    private val planDefRepo: PlanDefinitionRepository,
) {
    suspend operator fun invoke(initialPlanId: String): Result<ProviderPublicPlan> = runCatching {
        val sourcePlanVersion = getPlanDefinitionUseCase(id = initialPlanId).getOrThrow()
        val callable = functions.httpsCallable(PublicPlansConstants.Functions.GLOBAL_CREATE_NEW_PUBLIC_PLAN)

        val response = callable.invoke(
            CreateNewPublicPlanRequest(initialPlanDefinitionId = initialPlanId)
        )
        val result = response.data<CreateNewPublicPlanResponse>()

        if (result.success) {
            val summary = sourcePlanVersion.getContent(planDefRepo).summary()
            val newPublicPlan = repository.createPublicPlan(
                globalEntryId = result.globalEntryId,
                planId = initialPlanId,
                summary = summary,
                websiteLink = result.websiteLink,
                qrCodeUri = result.qrCodeUri,
                accessCode = result.accessCode,
            ).getOrThrow()
            newPublicPlan
        } else {
            throw Exception(result.message ?: "Failed to enable plan public")
        }

    }
}
